<template>
  <el-form
    :model="form"
    ref="form"
  >
    <el-row :gutter="20" class="bg-grey py-2 mb-4" >
      <el-col :lg="5" :sm="6" :xs="12">
        <el-form-item
          :label="L10n('customer')"
          prop="customerCompanyID"
          :rules="getValidationRule('required')"
          class="material-style"
        >
          <select-company
            :model.sync="form.customerCompanyID"
            @on-change="(value, data, label) => mixChangeCustomerID(value, { label, ...configRFQ })"
            @on-created="(data) => mixCreateCustomer(data, { label: data.name, ...configRFQ })"
          >
          </select-company>
        </el-form-item>
      </el-col>
      <el-col :lg="3" :sm="6" :xs="12">
        <el-form-item
          :label="L10n('requested-date')"
          prop="requestedDate"
          class="material-style"
        >
          <date-picker
            v-model="form.requestedDate"
            @change="autoSaveField('requestedDate', configRFQ)"
          ></date-picker>
        </el-form-item>
      </el-col>
      <el-col :lg="3" :sm="6" :xs="12">
        <el-form-item
          :label="L10n('rfq-type')"
          prop="rfqTypeID"
          class="material-style"
        >
          <select-response
            :model.sync="form.rfqTypeID"
            @on-change="(value, data, label) => autoSaveField('rfqTypeID', { label, ...configRFQ })"
            :isLoading="dataSourceRfqType.loading"
            :data="dataSourceRfqType.records"
          ></select-response>
        </el-form-item>
      </el-col>
      <el-col :lg="4" :sm="6" :xs="12">
        <el-form-item
          :label="L10n('core-due-date')"
          prop="coreDueDate"
          class="material-style"
        >
          <date-picker
            v-model="form.coreDueDate"
            @change="autoSaveField('coreDueDate', configRFQ3)"
          ></date-picker>
        </el-form-item>
      </el-col>
      <el-col :lg="3" :sm="6" :xs="12">
        <el-form-item
          :label="L10n('po')"
          :rules="getValidationRule('required')"
          prop="po"
          class="material-style"
        >
          <el-input
            :value="form.po"
            @input="form.po = valueTrimLeft($event)"
            @change="autoSaveField('po')"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :lg="3" :md="12" :sm="12" :xs="12">
        <el-form-item
          :label="L10n('part')"
          prop="partID"
          class="material-style"
        >
          <select-part-number
            :model.sync="form.partID"
            @on-change="(value, data, label) => autoSaveField('partID', { label })"
          ></select-part-number>
        </el-form-item>
      </el-col>
      <el-col :lg="3" :sm="6" :xs="24">
        <el-form-item
          :label="L10n('part-SN')"
          prop="partSN"
          class="material-style"
        >
          <el-input
            :value="form.partSN"
            @input="form.partSN = valueTrimLeft($event)"
            @change="autoSaveField('partSN')"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col>
        <view-more :isLazy="false">
          <div class="row">
            <div class="col-xl-2 col-lg-4 col-md-6 col-12">
              <el-form-item
                :label="L10n('price')"
                prop="price"
                class="material-style"
              >
                <el-input
                  :value="form.price"
                  @input="form.price = valueNumber($event)"
                  @change="autoSaveField('price', configRFQ3)"
                ></el-input>
              </el-form-item>
            </div>
            <div class="col-xl-2 col-lg-4 col-md-6 col-12">
              <el-form-item
                :label="L10n('currency')"
                prop="currencyID"
                :rules="getValidationRule('required')"
                class="material-style"
              >
                <select-response
                  :model.sync="form.currencyID"
                  @on-change="(value, data, label) => autoSaveField('currencyID', { label, ...configRFQ3 })"
                  :isLoading="dataSourceCurrency.loading"
                  :data="dataSourceCurrency.records"
                  :clearable="false"
                ></select-response>
              </el-form-item>
            </div>
            <div class="col-xl-2 col-lg-4 col-md-6 col-12">
              <el-form-item
                :label="L10n('condition')"
                prop="conditionID"
                :rules="getValidationRule('required')"
                class="material-style"
              >
                <select-response
                  :model.sync="form.conditionID"
                  @on-change="(value, data, label) => autoSaveField('conditionID', { label, ...configRFQ3 })"
                  :isLoading="dataSourceCondition.loading"
                  :data="dataSourceCondition.records"
                  :clearable="false"
                ></select-response>
              </el-form-item>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-6 col-12">
              <el-form-item
                :label="L10n('quoteDate')"
                prop="quoteDate"
                class="material-style"
              >
                <date-picker
                  v-model="form.quoteDate"
                  @change="autoSaveField('quoteDate', configRFQ3)"
                ></date-picker>
              </el-form-item>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-6 col-12">
              <el-form-item
                :label="L10n('supply-date')"
                :rules="getValidationRule('required')"
                prop="supplyDate"
                class="material-style"
              >
                <el-input
                  :value="form.supplyDate"
                  @input="form.supplyDate = valueTrimLeft($event)"
                  @change="autoSaveField('supplyDate', configRFQ3)"
                ></el-input>
              </el-form-item>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-6 col-12">
              <el-form-item
                :label="L10n('tag-info')"
                prop="tagInfoCompanyID"
                :rules="getValidationRule('required')"
                class="material-style"
              >
                <select-company
                  :model.sync="form.tagInfoCompanyID"
                  @on-change="(value, data, label) => autoSaveField('tagInfoCompanyID', { label, ...configRFQ3 })"
                >
                </select-company>
              </el-form-item>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-6 col-12">
              <el-form-item
                :label="L10n('tag-date')"
                prop="tagDate"
                class="material-style"
              >
                <date-picker
                  v-model="form.tagDate"
                  @change="autoSaveField('tagDate', configRFQ3)"
                ></date-picker>
              </el-form-item>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-6 col-12">
              <el-form-item
                :label="L10n('traceability-company')"
                prop="traceabilityCompanyID"
                class="material-style"
              >
                <select-company
                  :model.sync="form.traceabilityCompanyID"
                  @on-change="(value, data, label) => autoSaveField('traceabilityCompanyID', { label, ...configRFQ3 })"
                >
                </select-company>
              </el-form-item>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-6 col-12">
              <el-form-item
                :label="L10n('remarks')"
                prop="remarks"
                class="material-style"
              >
                <el-input
                  :value="form.remarks"
                  @input="form.remarks = valueTrimLeft($event)"
                  @change="autoSaveField('remarks', configRFQ3)"
                ></el-input>
              </el-form-item>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-6 col-12">
              <el-form-item
                :label="L10n('exchange-core-value')"
                prop="exchangeCoreValue"
                class="material-style"
              >
                <el-input
                  :value="form.exchangeCoreValue"
                  @input="form.exchangeCoreValue = valueTrimLeft($event)"
                  @change="autoSaveField('exchangeCoreValue', configRFQ3)"
                ></el-input>
              </el-form-item>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-6 col-12">
              <el-form-item
                :label="L10n('exchange-core-value-currency')"
                prop="exchangeCoreValueCurrencyID"
                class="material-style"
              >
                <select-response
                  :model.sync="form.exchangeCoreValueCurrencyID"
                  @on-change="(value, data, label) => autoSaveField('exchangeCoreValueCurrencyID', { label, ...configRFQ3 })"
                  :isLoading="dataSourceCurrency.loading"
                  :data="dataSourceCurrency.records"
                  :clearable="false"
                ></select-response>
              </el-form-item>
            </div>
            <div class="col-xl-2 col-lg-3 col-md-6 col-12">
              <el-form-item
                :label="L10n('exchange-condition')"
                prop="exchangeConditionID"
                class="material-style"
              >
                <select-response
                  :model.sync="form.exchangeConditionID"
                  @on-change="(value, data, label) => autoSaveField('exchangeConditionID', { label, ...configRFQ3})"
                  :isLoading="dataSourceCondition.loading"
                  :data="dataSourceCondition.records"
                  :clearable="false"
                ></select-response>
              </el-form-item>
            </div>
            <div class="col-xl-3 col-lg-4 col-md-6 col-12">
              <el-form-item
                :label="L10n('customer-contact')"
                prop="customerContactID"
                class="material-style">
                <select-company-contact
                  :companyID="form.customerCompanyID"
                  :model.sync="form.customerContactID"
                  @on-change="(value, data, label) => autoSaveField('customerContactID', { label, ...configRFQ })"
                ></select-company-contact>
              </el-form-item>
            </div>
            <div class="col-xl-2 col-lg-2 col-md-6 col-12">
              <el-form-item
                :label="L10n('qty')"
                prop="qty"
                class="material-style"
              >
                <el-input
                  :value="form.qty"
                  @input="form.qty = valueInteger($event)"
                  @change="autoSaveField('qty', configRFQ3)"
                ></el-input>
              </el-form-item>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-6 col-12">
              <el-form-item
                :label="L10n('observation')"
                prop="observation"
                class="material-style"
              >
                <el-input
                  :value="form.observation"
                  @input="form.observation = valueTrimLeft($event)"
                  @change="autoSaveField('observation', configRFQ)"
                />
              </el-form-item>
            </div>
            <div class="col-xl-2 col-lg-4 col-md-6 col-12">
              <el-form-item
                prop="exchangeCoreReceived"
                class="material-style"
              >
                <el-checkbox
                  v-model="form.exchangeCoreReceived"
                  @change="autoSaveField('exchangeCoreReceived', configRFQ3)"
                >
                  {{L10n('exchange-core-received')}}
                </el-checkbox>
              </el-form-item>
            </div>
            <div class="col-auto">
              <el-form-item
                class="material-style"
              >
                <button
                  v-if="isVisibleStockCard"
                  type="button"
                  class="btn btn-size-s btn-mobile-full"
                  @click.prevent.stop="handlerStockCard"
                >
                  {{L10n('stock-card')}}
                </button>
              </el-form-item>
            </div>
          </div>

        </view-more>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'
import { mixUpdateCustomer } from '@/mixins/companies'

export default {
  name: 'TopForm',
  mixins: [Form, mixUpdateCustomer],
  components: {
    'select-part-number': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectPartNumber/Index.vue'),
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue'),
    'select-company-contact': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyContact/Index'),
    'view-more': () => import(/* webpackChunkName: 'UI' */ '@/components/UI/ViewMore.vue')
  },
  props: {
    contactError: { required: true }
  },
  computed: {
    isVisibleStockCard () {
      return !!this.data.stockID
    },
    dataSourceEmployee () {
      return this.API('Employees/GetAllDynamic?select=id,name as title&filter=isActive==true')
    },
    dataSourceRfqType () {
      return this.API('RFQTypes/GetAllDynamic?select=id,title')
    },
    dataSourcePriority () {
      return this.API('Priorities/GetAllDynamic?select=id,title&orderBy=title')
    },
    dataSourcePaymentTerm () {
      return this.API('PaymentTerms/GetAllDynamic?select=id,title&orderBy=title')
    },
    dataSourceScore () {
      return this.API('Scores/GetAllDynamic?select=id,scoreText')
    },
    dataSourceCondition () {
      return this.API('Conditions/GetAllDynamic?select=id,title&orderBy=title asc')
    },
    dataSourceCurrency () {
      return this.API('Currencies/GetAllDynamic?select=id,title')
    },
    configRFQ () {
      return {
        id: this.form.rfqID,
        api: `RFQs/Patch/${this.form.rfqID}`
      }
    },
    configRFQ3 () {
      return {
        id: this.form.rfq3ID,
        api: `RFQ3s/Patch/${this.form.rfq3ID}`
      }
    }
  },
  methods: {
    handlerStockCard () {
      return this.$emit('onStockCard', this.data.stockID)
    }
  }
}
</script>
